import clsx from 'clsx'
import React, { CSSProperties } from 'react'

import { HTMLSliderElement, Slider, useSlider } from '@Components/Slider' // adjust path
import { SliderArrowLeft, SliderArrowRight } from '@Components/Slider/SliderArrows/SliderArrows'
import { SliderIndicator } from '@Components/Slider/SliderIndicator/SliderIndicator'

import styles from './styles.module.scss'

interface SliderWithArrowsAndIndicatorProps {
  arrowsClassName?: string
  className?: string
  hideArrows?: boolean
  hideIndicator?: boolean
  sliderClassName?: string
  style?: CSSProperties
}

export const SliderWithArrowsAndIndicator: React.FC<React.PropsWithChildren<SliderWithArrowsAndIndicatorProps>> = ({
  arrowsClassName,
  children,
  className,
  hideArrows = false,
  hideIndicator = false,
  sliderClassName,
  style,
}) => {
  const { onSlide, sliderRef, sliderState } = useSlider()

  return (
    <div className={clsx(styles.wrapper, className)} style={style}>
      {!hideArrows && (
        <>
          <SliderArrowLeft className={arrowsClassName} onClick={sliderRef.current?.prev} sliderState={sliderState} />
          <SliderArrowRight className={arrowsClassName} onClick={sliderRef.current?.next} sliderState={sliderState} />
        </>
      )}
      <Slider
        className={sliderClassName}
        onSlide={onSlide}
        ref={sliderRef as React.Ref<HTMLSliderElement>}
      >
        {children}
      </Slider>

      {!hideIndicator && (
        <SliderIndicator
          className={styles.range}
          onScrub={(value) => {
            if (sliderRef.current) {
              sliderRef.current.scrollLeft = value
            }
          }}
          sliderState={sliderState}
        />
      )}
    </div>
  )
}
